import React, { FC } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  text: string;
}

const ConfirmDialog: FC<ConfirmDialogProps> = ({ onClose, onConfirm, open, title, text }) => {

  return (
    <Dialog
        open={open}
        //onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <Button color="secondary" variant="contained" fullWidth onClick={onConfirm}>
            {text}
          </Button>  
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" autoFocus>
            Annuller
          </Button>
        </DialogActions>
      </Dialog>
  );
}

export default ConfirmDialog;